var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "140px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "剧场名称", prop: "theaterName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入剧场名称" },
                        model: {
                          value: _vm.childData.theaterName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "theaterName", $$v)
                          },
                          expression: "childData.theaterName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "容纳人数", prop: "capacity" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          placeholder: "请输入容纳人数"
                        },
                        model: {
                          value: _vm.childData.capacity,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "capacity", $$v)
                          },
                          expression: "childData.capacity"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人", prop: "userName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入联系人" },
                        model: {
                          value: _vm.childData.userName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "userName", $$v)
                          },
                          expression: "childData.userName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号", prop: "mobilephone" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入手机号" },
                        model: {
                          value: _vm.childData.mobilephone,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "mobilephone", $$v)
                          },
                          expression: "childData.mobilephone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "详细地址", prop: "address" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "请输入详细地址" },
                        model: {
                          value: _vm.childData.address,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "address", $$v)
                          },
                          expression: "childData.address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("el-divider"),
          _c(
            "el-row",
            [_c("el-col", { attrs: { span: 12 } }, [_vm._v(" 座位配置 ")])],
            1
          ),
          _c("el-row", [
            _c("div", { staticClass: "tipsRows" }, [
              _c("i", { staticClass: "el-icon-warning-outline tipsRows-i" }),
              _vm.currentStep == 0
                ? _c("span", [_vm._v("Step1：输入横排和竖排，并生成数据。")])
                : _vm._e(),
              _vm.currentStep == 1
                ? _c("span", [_vm._v("Step2：请单击选择非座位数据。")])
                : _vm._e(),
              _vm.currentStep == 2
                ? _c("span", [_vm._v("Step3：请单击数据可修改排号和座号。")])
                : _vm._e()
            ])
          ]),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域横排", prop: "rows" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          max: 50,
                          min: 5,
                          placeholder: "请输入横排",
                          disabled: _vm.disabledSq
                        },
                        model: {
                          value: _vm.childData.rows,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "rows", $$v)
                          },
                          expression: "childData.rows"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域竖排", prop: "cols" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "number",
                          max: 50,
                          min: 5,
                          placeholder: " 请输入竖排",
                          disabled: _vm.disabledSq
                        },
                        model: {
                          value: _vm.childData.cols,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "cols", $$v)
                          },
                          expression: "childData.cols"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("el-col", { attrs: { span: 8 } }, [
                _c(
                  "div",
                  { staticClass: "butRows" },
                  [
                    _vm.currentStep == 0
                      ? _c("el-button", { on: { click: _vm.createData } }, [
                          _vm._v("生成数据")
                        ])
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          disabled: _vm.currentStep >= 1 ? false : true
                        },
                        on: { click: _vm.prevStep }
                      },
                      [_vm._v("上一步")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled:
                            _vm.currentStep >= 1 && _vm.currentStep < 2
                              ? false
                              : true
                        },
                        on: { click: _vm.nextStep }
                      },
                      [_vm._v("下一步")]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm.currentStep == 1
            ? _c(
                "el-row",
                { attrs: { span: 24, type: "flex", justify: "center" } },
                [
                  _vm.disabledSq && _vm.seatData.length > 0
                    ? _c(
                        "div",
                        { staticClass: "rectangle" },
                        [
                          _c("div", { staticClass: "rowsx sticky" }, [
                            _c("div", { staticClass: "label colybg" }, [
                              _vm._v("行\\列")
                            ]),
                            _c(
                              "div",
                              { staticClass: "coly colybg" },
                              _vm._l(_vm.colsData, function(column1, columnY2) {
                                return _c(
                                  "div",
                                  { key: column1, staticClass: "itemTp" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s("第" + (columnY2 + 1) + "列") +
                                        " "
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]),
                          _vm._l(_vm.seatData, function(row, rowIndex) {
                            return _c(
                              "div",
                              { key: rowIndex, staticClass: "rowsx" },
                              [
                                _c("div", { staticClass: "label" }, [
                                  _vm._v(_vm._s("第" + (rowIndex + 1) + "行"))
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "coly" },
                                  _vm._l(row, function(column, colIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: colIndex,
                                        on: {
                                          click: function($event) {
                                            return _vm.clickItemStep1(
                                              rowIndex,
                                              colIndex
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class:
                                              _vm.seatData[rowIndex][colIndex]
                                                .Status == "0"
                                                ? "itemCss"
                                                : "itemCss1"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.seatData[rowIndex][
                                                        colIndex
                                                      ].Status == "0",
                                                    expression:
                                                      "seatData[rowIndex][colIndex].Status == '0'"
                                                  }
                                                ]
                                              },
                                              [
                                                _vm._v(
                                                  " (" +
                                                    _vm._s(
                                                      column.XCoord +
                                                        ", " +
                                                        column.YCoord +
                                                        " "
                                                    ) +
                                                    ")"
                                                )
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      _vm.seatData[rowIndex][
                                                        colIndex
                                                      ].Status == "-1",
                                                    expression:
                                                      "seatData[rowIndex][colIndex].Status == '-1'"
                                                  }
                                                ]
                                              },
                                              [_vm._v(" " + _vm._s("非座位"))]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ]
              )
            : _vm.currentStep == 2
            ? _c(
                "el-row",
                { attrs: { span: 24, type: "flex", justify: "center" } },
                [
                  _vm.seatData.length > 0
                    ? _c(
                        "div",
                        { staticClass: "rectangle borderCss" },
                        _vm._l(_vm.seatData, function(row, rowIndex) {
                          return _c(
                            "div",
                            { key: rowIndex, staticClass: "rowsx" },
                            [
                              _c(
                                "div",
                                { staticClass: "coly" },
                                _vm._l(row, function(column, colIndex) {
                                  return _c(
                                    "div",
                                    {
                                      key: colIndex,
                                      on: {
                                        click: function($event) {
                                          return _vm.clickItemStep2(
                                            rowIndex,
                                            colIndex
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value:
                                                _vm.seatData[rowIndex][colIndex]
                                                  .Status == "0",
                                              expression:
                                                "seatData[rowIndex][colIndex].Status == '0'"
                                            }
                                          ],
                                          staticClass: "itemCss"
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  column.RowNum +
                                                    "排" +
                                                    column.ColumnNum +
                                                    "座"
                                                )
                                            )
                                          ])
                                        ]
                                      ),
                                      _c("div", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.seatData[rowIndex][colIndex]
                                                .Status == "-1",
                                            expression:
                                              "seatData[rowIndex][colIndex].Status == '-1'"
                                          }
                                        ],
                                        staticClass: "itemCssNo"
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.selectItem
        ? _c(
            "el-form",
            {
              staticClass: "rowcolForm",
              attrs: {
                model: _vm.childData,
                "label-position": "right",
                "label-width": "140px"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "number",
                              max: 50,
                              min: 5,
                              placeholder: "请输入排号"
                            },
                            model: {
                              value: _vm.selectItem.RowNum,
                              callback: function($$v) {
                                _vm.$set(_vm.selectItem, "RowNum", $$v)
                              },
                              expression: "selectItem.RowNum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "座号" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "number",
                              max: 50,
                              min: 5,
                              placeholder: "请输入座号"
                            },
                            model: {
                              value: _vm.selectItem.ColumnNum,
                              callback: function($$v) {
                                _vm.$set(_vm.selectItem, "ColumnNum", $$v)
                              },
                              expression: "selectItem.ColumnNum"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.closeEditRowCol }
                        },
                        [_vm._v("关闭")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }